import "./index.scss";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="footer__content">
              <div className="footer__logo">
                <svg
                  width="205"
                  height="45"
                  viewBox="0 0 205 45"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_4_927)">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M63.6487 39.0372C54.9261 39.0372 47.8549 31.966 47.8549 23.2432L63.6487 7.44934C72.3715 7.44934 79.4427 14.5205 79.4427 23.2432C79.4427 24.609 79.2693 25.9341 78.9435 27.1979H56.5006C57.8965 29.6912 60.5634 31.3765 63.624 31.3765H75.3637V39.0372C74.0247 39.0372 64.9345 39.0372 63.6487 39.0372ZM63.624 15.0602C66.7047 15.0602 69.3868 16.768 70.7748 19.2885H56.4729C57.861 16.768 60.5431 15.0602 63.624 15.0602Z"
                      fill="black"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M25.2254 0.996094H17.3356L17.286 23.1527V23.7513C17.286 32.4729 24.3396 39.5431 33.0407 39.5431C41.7419 39.5431 48.7956 32.4729 48.7956 23.7513C48.7956 15.0297 41.7419 7.95942 33.0407 7.95942C29.7431 7.95942 26.6288 9.22664 25.2254 10.3389V0.996094ZM33.0159 31.8835C37.5104 31.8835 41.1538 28.2314 41.1538 23.7264C41.1538 19.2213 37.5104 15.5694 33.0159 15.5694C28.5215 15.5694 24.878 19.2213 24.878 23.7264C24.878 28.2314 28.5215 31.8835 33.0159 31.8835Z"
                      fill="black"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M187.664 0.996094H179.775V10.3389C178.371 9.22664 175.257 7.95942 171.959 7.95942C163.258 7.95942 156.204 15.0297 156.204 23.7513C156.204 32.2633 162.923 39.2024 171.335 39.531L187.714 23.152L187.664 0.996094ZM163.846 23.7264C163.846 28.2314 167.49 31.8835 171.984 31.8835C176.479 31.8835 180.122 28.2314 180.122 23.7264C180.122 19.2213 176.479 15.5694 171.984 15.5694C167.49 15.5694 163.846 19.2213 163.846 23.7264Z"
                      fill="black"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M89.0804 45.9961H81.1906L81.1409 23.8395V23.241C81.1409 14.5193 88.1946 7.4491 96.8957 7.4491C105.597 7.4491 112.65 14.5193 112.65 23.241C112.65 31.9626 105.597 39.0328 96.8957 39.0328C93.598 39.0328 90.4837 37.7656 89.0804 36.6534V45.9961ZM96.8708 15.1088C101.365 15.1088 105.009 18.7608 105.009 23.2658C105.009 27.7709 101.365 31.4229 96.8708 31.4229C92.3764 31.4229 88.7329 27.7709 88.7329 23.2658C88.7329 18.7608 92.3764 15.1088 96.8708 15.1088Z"
                      fill="black"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M136.612 39.0377H144.606L144.656 24.0923V23.4135C144.656 14.597 137.509 7.44983 128.692 7.44983C119.876 7.44983 112.729 14.597 112.729 23.4135C112.729 32.2301 119.876 39.3774 128.692 39.3774L136.612 31.4584V39.0377ZM128.718 15.1929C124.164 15.1929 120.472 18.8847 120.472 23.4388C120.472 27.9928 124.164 31.6845 128.718 31.6845C133.272 31.6845 136.963 27.9928 136.963 23.4388C136.963 18.8847 133.272 15.1929 128.718 15.1929Z"
                      fill="black"
                    />
                    <path
                      d="M146.719 15.2188H154.551V39.0376H146.719V15.2188Z"
                      fill="black"
                    />
                    <path
                      d="M146.694 0.996094H154.531V8.83345H146.694V0.996094Z"
                      fill="#FF8E09"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_4_927">
                      <rect width="205" height="45" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
